import { IconBase, IconProps } from '../base/IconBase';

export const ChevronRightIcon = (props: IconProps) => {
	const { variant = 'rounded', ...rest } = props;

	const renderPaths = () => {
		switch (variant) {
			case 'rounded':
				return (
					<path d="M531.69-480 361.85-649.85q-5.62-5.61-6-13.77-.39-8.15 6-14.53 6.38-6.39 14.15-6.39 7.77 0 14.15 6.39l175.54 175.53q5.23 5.24 7.35 10.7 2.11 5.46 2.11 11.92t-2.11 11.92q-2.12 5.46-7.35 10.7L390.15-281.85q-5.61 5.62-13.77 6-8.15.39-14.53-6-6.39-6.38-6.39-14.15 0-7.77 6.39-14.15L531.69-480Z" />
				);

			case 'fw400':
				return (
					<path d="M504-480 348-636q-11-11-11-28t11-28q11-11 28-11t28 11l184 184q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L404-268q-11 11-28 11t-28-11q-11-11-11-28t11-28l156-156Z" />
				);

			case 'custom':
				return (
					<path d="M504-480 348-636q-11-11-11-28t11-28q11-11 28-11t28 11l184 184q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L404-268q-11 11-28 11t-28-11q-11-11-11-28t11-28l156-156Z" />
				);

			default:
				return null;
		}
	};

	return <IconBase {...rest}>{renderPaths()}</IconBase>;
};
